import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=6e66c3ae&scoped=true&"
import script from "./EmployeeCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=6e66c3ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e66c3ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VChip})
